import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row, Media, Input } from "reactstrap";
import { Btn, H3, Breadcrumbs, H5 } from "../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SpinnerLoader from "../../Layout/SpinnerLoader/index";
import {
    paymentMethod, addInvoicePayment, paymentSelectbox, paymentMethodRole, paymentSelectboxRole, addInvoicePaymentRole,
    paymentformtype, paymentformtypeRole,
} from "../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../Utils/restUtils";
import { toast } from "react-toastify";
import Typeahead from "../../CommonElements/TypeAhead/index";
import DatePicker from 'react-datepicker';
import {
    PaymentMethod, DateText, Description, Save, Reference, Total, BinAccount, totalPending, Walletbalance, Payfromwallet,
    quickPay, CollectAmount, Type
} from "../../Constant/index";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Transparentspinner from "../Common/Loader/Transparentspinner";
import SweetAlert from 'sweetalert2';
import CustomerDropdown from "../Common/CustomerField/CustomerDropdown";
import Select from 'react-select';
import moment from "moment";
import HandleApiError from "../Common/ErrorImport/ErrorImport";

const schema = yup.object().shape({
    customer: yup.mixed().required().label('Customer'),
    amount: yup.string().required().label('Amount'),
    paymentMethod: yup.mixed().when('payment', {
        is: (value) => value == true,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required().label('payment required'),
    }),
});

const Quickpay = () => {
    const [spinnerTrans, setspinnerTrans] = useState(false)
    const { register, handleSubmit, control, formState: { errors }, setValue, getValues, reset } = useForm({
        resolver: yupResolver(schema),
    });

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            height: '44px', // Set your desired height here
            minHeight: '44px', // Ensure the minimum height is also set
            borderColor: state.isFocused ? '#534686' : '#d2d2d2', // Change border color on focus
            boxShadow: state.isFocused ? '0 0 0 1px #534686' : provided.boxShadow, // Ensure box shadow matches border color
            '&:hover': {
                borderColor: state.isFocused ? '#534686' : '#d2d2d2' // Change border color on hover when focused
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '44px', // Match the height here as well
            display: 'flex',
            alignItems: 'center',
        }),
        input: (provided) => ({
            ...provided,
            height: '44px', // Ensure the input area height matches
            padding: '0',
            margin: '0',
        }),
    };

    const authState = useSelector((state) => state.auth);
    const [startDate, setstartDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [Payment, setPayment] = useState([]);
    const [stbapiOption, setStbapiOption] = useState([]);
    const [selectedCust, setSelectedCust] = useState('');
    const [isChecked, setisChecked] = useState(false);
    const [isAmount, setisAmount] = useState('');
    const [decimalWalletbalance, setdecimalWalletbalance] = useState('')
    const navigate = useNavigate();

    useEffect(() => {
        const inputElement = document.querySelectorAll('input[type="number"]');

        const preventScrollEvent = (event) => {
            event.preventDefault();
        };

        inputElement.forEach((inputElement) => {
            inputElement.addEventListener('wheel', preventScrollEvent);
            return () => {
                inputElement.forEach((inputElement) => {
                    inputElement.removeEventListener('wheel', preventScrollEvent);
                });
            };
        });
    }, []);

    const type = [
        { value: '', label: "Any" },
        { value: 'sales_order', label: 'Sales Order' },
        { value: 'subscription', label: 'Subscription' },
    ];


    useEffect(() => {
        paymentData();
    }, []);

    useEffect(() => {
        if (selectedCust !== null) { // Ensure it's triggered only when selectedCust is updated
            const typeValue = getValues('type')?.value || '';
            selectType(typeValue, selectedCust);
        }
    }, [selectedCust]);


    const handleChangeDate = date => {
        setstartDate(date);
    };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setValue("payment", isChecked);
        setisChecked(isChecked);
        if (isChecked == true) {
            document.getElementById("amount").disabled = true;
            const walt_balnc = getValues("wallet");
            setValue("wallet_money", 1);
            if (parseFloat(isAmount) >= parseFloat(walt_balnc)) {
                setValue("amount", walt_balnc);
            } else if (parseFloat(isAmount) < parseFloat(walt_balnc)) {
                setValue("amount", isAmount);
            }
        } else {
            // setValue("amount", isAmount);
            document.getElementById("amount").disabled = false;
            setValue("wallet_money", null);
        }
    }

    const paymentData = async () => {
        const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? paymentMethod : paymentMethodRole);
        if (payment.status === true) {
            const set_payment = payment.data.map((itemss) => ({
                value: itemss.id,
                label: itemss.name,
            }));
            setPayment(set_payment);
        } else {
            HandleApiError(payment.status);
        }
    };

    const selectType = async (typeSelected, customer) => {
        setspinnerTrans(true);
        const customer_id = Number(selectedCust) ? Number(selectedCust) : customer;
        if (customer_id) {
            const selected_con = typeSelected ? typeSelected : '';
            const stb_get_api = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? paymentformtype + `?customer_id=${customer_id}&connection_type=${selected_con}` :
                paymentformtypeRole + `?customer_id=${customer_id}&connection_type=${selected_con}`);
            if (stb_get_api.status === true) {
                const single_stb = stb_get_api.data.stbs;
                const stbType = single_stb.map((item) => ({
                    value: item.id,
                    label: item.stb_no,
                }))
                setStbapiOption(stbType);
                if (stbType) {
                    const findstb = stbType.find((s) => s.value == selected_con);
                    setValue("stb", findstb)
                    selectAmountType(selected_con, findstb);
                }
            } else {
                HandleApiError(stb_get_api.status);
            }
        }
        setspinnerTrans(false);
    }

    const selectAmountType = async (typeValue, stbId) => {
        try {
            setspinnerTrans(true);
            if (!selectedCust) return;
            const customer_id = Number(selectedCust);
            const selected_con = typeValue || '';
            const stbIdArray = Array.isArray(stbId) ? stbId : [{ value: stbId }];
            const selected_stb = stbIdArray.map(item => item.value);
            const buildApiUrl = (base, role) => (
                `${base}?customer_id=${customer_id}&connection_type=${selected_con}&stb_id=${selected_stb}`
            );
            const apiUrl = buildApiUrl(authState.userRole === 1 ? paymentSelectbox : paymentSelectboxRole, authState.userRole);
            const type_get_api = await getClientUrlDataToken(authState.apiUrl, apiUrl);
            if (type_get_api.status === true) {
                const { total_pending_amount, total_payable, wallet_amount } = type_get_api.data;
                const formatValue = value => value.replace(/,/g, '') || 0;
                const pendingAmount = formatValue(total_pending_amount);
                const totalPayable = formatValue(total_payable);
                const walletBalance = formatValue(wallet_amount);
                setValue("pending", pendingAmount);
                setValue("total", totalPayable);
                setdecimalWalletbalance(walletBalance);
                setValue("wallet", walletBalance);
                setisAmount(totalPayable);
            } else {
                HandleApiError(type_get_api.status);
            }
        } catch (error) {
            console.error('Error in selectAmountType:', error);
        } finally {
            setspinnerTrans(false);
        }
    };

    const onCustomerChange = (value) => {
        const customer = value.value;
        setSelectedCust(customer);
    };

    const handleSwitchToggle = async (data, subId) => {
        const getAmount = getValues("amount")
        SweetAlert.fire({
            title: `<b>Amount </b>:  ${getAmount} `,
            text: 'Note : Once the payment is processed, it cannot be reversed, and no changes are allowed.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then(async (result) => {
            if (!result.value) {
                return;
            }
            setLoading(true);
            const isCheckedwallet = getValues("wallet_money")
            const selected_stb = Array.isArray(data.stb) ? data.stb.map(item => item.value) : [];
            const postRequest = {
                customer_id: selectedCust,
                connection_type: data.type.value,
                amount: data.amount,
                paid_at: moment(new Date(startDate)).format('D-M-YYYY'),
                ...(data.type.value === 'subscription' && { stb_id: selected_stb }),
                payment_method: data.paymentMethod?.value || '',
                reference: data.reference,
                description: data.description,
                wallet_money: isCheckedwallet,
            };
            const addAddonResponse = await postClientUrlWithToken(
                authState.apiUrl, authState.userRole === 1 ? addInvoicePayment : addInvoicePaymentRole, postRequest
            );
            if (addAddonResponse.status === 200) {
                if (addAddonResponse.data.status === true) {
                    toast.success(addAddonResponse.data.message);
                    const paymentID = addAddonResponse.data.data;
                    navigate(`${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${paymentID}`);

                } else if (Array.isArray(addAddonResponse.data?.message)) {
                    const error = addAddonResponse.data.map((e) => e.message)
                    toast.error(error);
                } else {
                    toast.error(addAddonResponse.data.message);
                }
            } else if (addAddonResponse.status >= 400 && addAddonResponse.status <= 405) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
            } else if (addAddonResponse.status >= 500 && addAddonResponse.status <= 505) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            }
            setLoading(false);
        })
    };

    return (
        <Fragment>
            {loading && <SpinnerLoader />}
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={quickPay} parent="Billing" title={quickPay} />
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(handleSwitchToggle)}>
                <Card>
                    <CardHeader className="pb-0">
                        <H3>{quickPay}</H3>
                    </CardHeader>
                    <CardBody>
                        <Row className="g-3 pt-2">
                            <CustomerDropdown
                                control={control}
                                errors={errors}
                                onCustomerChange={onCustomerChange}
                            />
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">
                                    {Type}
                                </Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    defaultValue={type[2]}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={type}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                const typevalue = value.value;
                                                selectType(typevalue);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.type?.message}</p>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            {getValues('type')?.value === 'subscription' && (
                                <Col md="6" className="mt-3">
                                    <Label className="form-label" for="multiple-typeahead">{BinAccount}</Label>
                                    <Controller
                                        name="stb"
                                        control={control}
                                        render={({ field }) => {
                                            console.log('field', field);
                                            return (
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    isMulti
                                                    styles={customStyles}
                                                    // onChange={(value) => handleInvoiceChange(value, field)}
                                                    onChange={(value) => {
                                                        const typeValue = getValues('type') ? getValues('type').value : ''; // Get the connection type value
                                                        selectAmountType(typeValue, value);
                                                        field.onChange(value);
                                                    }}
                                                    value={field.value}
                                                    options={stbapiOption}
                                                />
                                            )
                                        }}
                                    />
                                </Col>
                            )}
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">
                                    {totalPending}
                                </Label>
                                <input
                                    className="form-control"
                                    id="validationCustom02"
                                    disabled
                                    type="number"
                                    {...register("pending", { required: true })}
                                />
                                <p className="text-danger">{errors.account?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">
                                    {Total}
                                </Label>
                                <input
                                    className="form-control"
                                    id="validationCustom02"
                                    disabled
                                    type="number"
                                    {...register("total", { required: true })}
                                />
                                <p className="text-danger">{errors.amount?.message}</p>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">
                                    {CollectAmount} <span className="requireStar">*</span>
                                </Label>
                                <input
                                    name="amount"
                                    className="form-control"
                                    id="amount"
                                    type="number"
                                    min="0"
                                    {...register("amount", { required: true })}
                                />
                                <p className="text-danger">{errors.amount?.message}</p>
                            </Col>
                            {isAmount > 0 && decimalWalletbalance > 0 && (
                                <Col md="6" className="">
                                    <Card>
                                        <Media className="d-flex p-20">
                                            <div className="form-check me-3">
                                                <Input className="wallet-checkbox" id="checkbox-primary-1" type="checkbox" checked={isChecked} onChange={handleCheckboxChange} style={{ transform: 'scale(1.7)' }} />
                                                <Label for="checkbox-primary-1"></Label>
                                            </div>
                                            <Media body className='flex-grow-1'>
                                                <H3 attrH6={{ className: "mt-0 mega-title-badge" }}>{Walletbalance}<span className="badge badge-primary pull-right digits">{authState.currency} {decimalWalletbalance}</span></H3>
                                                <H5>{Payfromwallet}</H5>
                                            </Media>
                                        </Media>
                                    </Card>
                                </Col>
                            )}
                            {isChecked == false && (
                                <Col md="6">
                                    <Label className="form-label" for="validationCustom02">
                                        {PaymentMethod} <span className="requireStar">*</span>
                                    </Label>
                                    <Controller
                                        name="paymentMethod"
                                        control={control}
                                        render={({ field }) => (
                                            <Typeahead
                                                options={Payment}
                                                onChange={(value) => {
                                                    field.onChange(value);
                                                }}
                                                value={field.value}
                                            />
                                        )}
                                    />

                                    <p className="text-danger">{errors.paymentMethod?.message}</p>
                                </Col>
                            )}
                            <Col md="6">
                                <FormGroup className="mb-3">
                                    <Label className="form-label" for="validationCustom02">
                                        {DateText}
                                    </Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <DatePicker
                                            style={{ padding: '12px 100px' }}
                                            className="form-control "
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="dd/mm/yyyy"
                                            selected={startDate}
                                            onChange={handleChangeDate}
                                            required
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="validationCustom02">
                                    {Reference}
                                </Label>
                                <input
                                    className="form-control"
                                    id="validationCustom02"
                                    type="text"
                                    {...register("reference", { required: true })}
                                />
                                <p className="text-danger">{errors.name?.message}</p>
                            </Col>
                        </Row>
                        <Row className="g-3">
                            <Col>
                                <Label className="form-label pt-3">{Description}</Label>
                                <Controller
                                    name="description"
                                    control={control}
                                    render={({ field }) => (
                                        <textarea className="form-control" {...field} rows="3" />
                                    )}
                                />
                            </Col>
                        </Row>
                        <FormGroup></FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">
                            {Save}
                        </Btn>
                    </CardBody>
                </Card>
            </Form>
        </Fragment>
    )
}

export default Quickpay